<!--
  通用banner!
-->
<template>
  <div class="common-banner">
    <img :src="bannerImg" alt="">
    <!-- <ab-img class="img" :width="1920" :height="560" :src="bannerImg" /> -->
  </div>
</template>

<script>
  export default {
    name: '',
    components: {},
    props: {
      bannerType: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        bannerImg: '',
        bannerWidth: 1920,
        list: []
      }
    },
    methods: {
      fetch() {
        this.$api
          .pcBanner({
            AdNo: this.bannerType
          })
          .then(res => {
            this.list = res.result.items;
            let currentNum = this.randomNum(0, this.list.length - 1)
            console.log(currentNum, "currentNum")
            if (this.list[currentNum])
              this.bannerImg = this.list[currentNum].imagePath
          })
      },
      randomNum(minNum, maxNum) {
        switch (arguments.length) {
          case 1:
            return parseInt(Math.random() * minNum + 1, 10);
            break;
          case 2:
            return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
            break;
          default:
            return 0;
            break;
        }
      }
    },
    created() {
      this.fetch()
    }
  }

</script>

<style lang="scss" scoped>
  .common-banner {
    width: 100%;
    // height: 560px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    min-width: 1200px;

    // .img {
    //   margin: 0 auto;
    //   display: block;
    //   position: absolute;
    //   left: 50%;
    //   margin-left: -960px;
    //   z-index: -999;
    // }
    img {
      position: relative;
      width: 100%;
      display: block;
      z-index: -999;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/commonBanner.vue